import React, { useCallback, useMemo, useState, useEffect } from 'react';
import './SideBar.scss';
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const SideBar = () => {
  const role = localStorage.getItem('userRole');
  const location = useLocation();
  return (
    <div className="sideBar">
      {/* <div
        className={`sideBarContent ${location.pathname === '/collectionCenter/dashboard' ? 'active' : ''}`}
      >
        <NavLink to="/collectionCenter/dashboard">Dashboard</NavLink>
      </div>
      <div className="sideBarContent">
        <Accordion
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
            paddingLeft: '1rem',
          }}
        >
          <AccordionSummary
            sx={{ padding: '0px', textAlign: 'center' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            HR & Items Master
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            <NavLink to="/collectionCenter/employeeSetup">
              Employee Setup
            </NavLink>
            <NavLink to="/" style={{ marginTop: '10px' }}>
              Update Items
            </NavLink>
          </AccordionDetails>
        </Accordion>
      </div>
      <Divider sx={{ opacity: 0.5, margin: '20px 0px' }} />

      <div
        className={`sideBarContent ${location.pathname === '/' ? 'active' : ''}`}
      >
        <NavLink to="/">Stock Movement</NavLink>
      </div> */}
      <div
        className={`sideBarContent ${location.pathname === '/collectionCenter/collectionOrder' ? 'active' : ''}`}
      >
        <NavLink to="/collectionCenter/collectionOrder">
          Collection Center Order
        </NavLink>
      </div>
      <div
        className={`sideBarContent ${location.pathname === '/collectionCenter/generatedGnr' ? 'active' : ''}`}
      >
        <NavLink to="/collectionCenter/generatedGnr">Generated GRN</NavLink>
      </div>
      <div
        className={`sideBarContent ${location.pathname === '/collectionCenter/receiveDelivery' ? 'active' : ''}`}
      >
        <NavLink to="/collectionCenter/receiveDelivery">
          Receive Delivery
        </NavLink>
      </div>
      <div
        className={`sideBarContent ${location.pathname === '/collectionCenter/addEmp' ? 'active' : ''}`}
      >
        <NavLink to="/collectionCenter/addEmp">Add Employee</NavLink>
      </div>
      <div
        className={`sideBarContent ${location.pathname === '/collectionCenter/deliveryEmp' ? 'active' : ''}`}
      >
        <NavLink to="/collectionCenter/deliveryEmp">Delivery To Emp</NavLink>
      </div>
    </div>
  );
};
export default SideBar;
